import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from 'components/common/layouts';
import { DocumentSearchIcon } from 'components/common_v2/icons';
import { DescriptionDecorator } from 'components/common/form/decorators';
import { compose } from 'utilities/functions/composition';

const HeaderContainer = styled.span`
  font-size: 21px;
  color: ${({ theme }) => theme.colors.text02};
`;

const ContentConatiner = compose(DescriptionDecorator)(HeaderContainer);

export const NoResults = ({ contentText, headerText, ...rest }) => (
  <Box flexDirection="column" alignItems="center" {...rest}>
    <DocumentSearchIcon />
    {headerText && <ContentConatiner data-test-id="no-results__text" description={contentText}>{headerText}</ContentConatiner>}
  </Box>
);

NoResults.propTypes = {
  contentText: PropTypes.string,
  headerText: PropTypes.string.isRequired,
};

NoResults.defaultProps = {
  contentText: undefined
};

export default NoResults;
